'use client';

import { usePathname } from 'next/navigation';
import type { ReactNode } from 'react';

/** Wraps every route with a fade-up entrance animation.
 *  Re-keys on pathname so navigation re-triggers the animation; reduced-motion is respected via CSS. */
export default function PageTransition({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  return (
    // Center every route in a 1440px column on wide screens (no-op ≤1440px).
    // Header/footer bars stay full-bleed; their inner content is capped to match.
    <div key={pathname} className="page-transition mx-auto w-full min-w-0 max-w-[1440px] flex-1">
      {children}
    </div>
  );
}
